import React from 'react';
import styles from '../../styles/portfolio/short_desc.scss';


export const TLSManager = props => {
    return (
        <div className={styles.description}>
            <div className={styles.containerGeneric}>
                An AWS serverless lambda function that uses certbot in order to automatically create or refresh TLS certificates provided by Let’s Encrypt.
                Certificates are shared among AWS resources <i> (such as Lambdas, EC2, or ECS instances)</i> through EFS
                <i> (Amazon's Elastic File System)</i>.
                <span className={styles.tagContainer}>TLS</span>
                <span className={styles.tagContainer}>Serverless</span>
                <span className={styles.tagContainer}>Let’s Encrypt</span>
            </div>
        </div>
    )
};
